import { connect } from "react-redux";
import { Box } from "@mui/system";
import { Typography, Avatar } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";

const WelcomeText = ({ user, pLoading }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const location = useLocation();
  const pathname = location.pathname;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="p" sx={{ lineHeight: "23px", fontSize: isMobile ? "14px" : "20px" }}>
        Hi {user?.studentName ? `${user.studentName}!` : pLoading ? "" : ""}{" "}
        Welcome
      </Typography>
      <Box  sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <Avatar alt="School logo" src={user?.schoolLogo} />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: isMobile ? "14px" : "18px",
        }}
      >
         {pathname === "/dashboard" ? user?.schoolName : user?.schoolAbrv}
      </Typography>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  user: state.userState.user,
  pLoading: state.userState.loading,
});

export default connect(mapStateToProps)(WelcomeText);
